import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { type FC, memo } from 'react';

const BareExchangeIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 10 22' {...props}>
    {}
    <path d='M3.006 17H6V8h1v9h2.993l-3.494 4.243L3.006 17zM3 14V5H.007L3.501.757 6.994 5H4v9H3z' />
  </SvgWrapper>
);
export const ExchangeIcon = memo(BareExchangeIcon);
